(function () {
  var sectionIntervals = {};

  function hasExplicitOffset(value) {
    return /(?:[zZ]|[+-]\d{2}:?\d{2})$/.test(String(value || '').trim());
  }

  function parseIsoParts(value) {
    if (!value) return null;
    var normalized = String(value)
      .trim()
      .replace(' ', 'T');
    var match = normalized
      .match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/);

    if (!match) return null;

    return {
      year: Number(match[1]),
      month: Number(match[2]),
      day: Number(match[3]),
      hour: Number(match[4]),
      minute: Number(match[5]),
      second: Number(match[6] || 0),
    };
  }

  function getTimeZoneOffset(date, timeZone) {
    var formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      hour12: false,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });

    var parts = formatter.formatToParts(date);
    var map = {};

    parts.forEach(function (part) {
      if (part.type !== 'literal') {
        map[part.type] = part.value;
      }
    });

    var asUTC = Date.UTC(
      Number(map.year),
      Number(map.month) - 1,
      Number(map.day),
      Number(map.hour),
      Number(map.minute),
      Number(map.second)
    );

    return asUTC - date.getTime();
  }

  function zonedCalendarKey(date, timeZone) {
    if (!date || Number.isNaN(date.getTime())) {
      return '';
    }

    if (!timeZone || !String(timeZone).trim()) {
      return (
        date.getUTCFullYear() +
        '-' +
        pad(date.getUTCMonth() + 1) +
        '-' +
        pad(date.getUTCDate())
      );
    }

    try {
      var formatter = new Intl.DateTimeFormat('en-CA', {
        timeZone: timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
      var parts = formatter.formatToParts(date);
      var map = {};

      parts.forEach(function (part) {
        if (part.type !== 'literal') {
          map[part.type] = part.value;
        }
      });

      return map.year + '-' + map.month + '-' + map.day;
    } catch (error) {
      return (
        date.getUTCFullYear() +
        '-' +
        pad(date.getUTCMonth() + 1) +
        '-' +
        pad(date.getUTCDate())
      );
    }
  }

  function zonedTimeToDate(value, timeZone) {
    if (hasExplicitOffset(value)) {
      var explicitDate = new Date(value);
      return Number.isNaN(explicitDate.getTime()) ? null : explicitDate;
    }

    var parts = parseIsoParts(value);
    if (!parts) return null;

    if (!timeZone) {
      var fallback = new Date(value);
      return Number.isNaN(fallback.getTime()) ? null : fallback;
    }

    try {
      var utcGuess = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
      var guessDate = new Date(utcGuess);
      var offset = getTimeZoneOffset(guessDate, timeZone);
      var corrected = utcGuess - offset;
      var correctedDate = new Date(corrected);
      var secondOffset = getTimeZoneOffset(correctedDate, timeZone);

      if (offset !== secondOffset) {
        corrected = utcGuess - secondOffset;
        correctedDate = new Date(corrected);
      }

      return correctedDate;
    } catch (error) {
      var direct = new Date(value);
      return Number.isNaN(direct.getTime()) ? null : direct;
    }
  }

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function updateCountdownTimer(timer, now) {
    if (!timer) return;
    var target = zonedTimeToDate(timer.getAttribute('data-auction-countdown'), timer.getAttribute('data-auction-timezone'));
    var diff = target ? Math.max(0, target.getTime() - now) : 0;
    var days = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var minutes = Math.floor((diff % 3600000) / 60000);
    var seconds = Math.floor((diff % 60000) / 1000);

    var daysNode = timer.querySelector('[data-days]');
    var hoursNode = timer.querySelector('[data-hours]');
    var minutesNode = timer.querySelector('[data-minutes]');
    var secondsNode = timer.querySelector('[data-seconds]');

    if (daysNode) daysNode.textContent = pad(days);
    if (hoursNode) hoursNode.textContent = pad(hours);
    if (minutesNode) minutesNode.textContent = pad(minutes);
    if (secondsNode) secondsNode.textContent = pad(seconds);
  }

  function updateEmptyBlocks(root) {
    if (!root) return;

    var containers = root.querySelectorAll('[data-auction-hide-empty]');

    containers.forEach(function (container) {
      var isFilled = container.getAttribute('data-auction-filled') === 'true';
      if (!isFilled) {
        isFilled = Boolean(container.querySelector('[data-auction-filled="true"]'));
      }

      container.hidden = !isFilled;
    });
  }

  function initCountdown(root) {
    if (!root) return;

    var sectionId = root.getAttribute('id');
    if (sectionIntervals[sectionId]) {
      clearInterval(sectionIntervals[sectionId]);
      delete sectionIntervals[sectionId];
    }

    var timers = Array.prototype.slice.call(root.querySelectorAll('[data-auction-countdown]'));
    if (!timers.length) return;

    function tick() {
      var now = Date.now();

      timers.forEach(function (timer) {
        updateCountdownTimer(timer, now);
      });
    }

    tick();
    sectionIntervals[sectionId] = window.setInterval(tick, 1000);
  }

  function initAuctionPhases(root, phaseRoots) {
    if (!root || !phaseRoots || !phaseRoots.length) return;

    var sectionId = root.getAttribute('id');
    if (sectionIntervals[sectionId]) {
      clearInterval(sectionIntervals[sectionId]);
      delete sectionIntervals[sectionId];
    }

    var list = Array.prototype.slice.call(phaseRoots);

    function tick() {
      var now = Date.now();

      list.forEach(function (phaseRoot) {
        var tz = phaseRoot.getAttribute('data-auction-timezone');
        var startVal = phaseRoot.getAttribute('data-auction-start');
        var endVal = phaseRoot.getAttribute('data-auction-end');
        var end = zonedTimeToDate(endVal, tz);

        if (!end || Number.isNaN(end.getTime())) {
          return;
        }

        var start = startVal ? zonedTimeToDate(startVal, tz) : null;
        var startOk = start && !Number.isNaN(start.getTime());
        var phase;
        var endMs = end.getTime();
        var endDayKey = zonedCalendarKey(end, tz);
        var nowDayKey = zonedCalendarKey(new Date(now), tz);
        var sameEndDay = Boolean(endDayKey && nowDayKey === endDayKey);
        var startedOrNoStart = !startOk || now >= start.getTime();

        if (now >= endMs) {
          phase = 'closed';
        } else if (sameEndDay && now < endMs && startedOrNoStart) {
          phase = 'live';
        } else {
          phase = 'pre';
        }

        var preEl = phaseRoot.querySelector('[data-auction-phase="pre"]');
        var liveEl = phaseRoot.querySelector('[data-auction-phase="live"]');
        var closedEl = phaseRoot.querySelector('[data-auction-phase="closed"]');

        if (preEl) preEl.hidden = phase !== 'pre';
        if (liveEl) liveEl.hidden = phase !== 'live';
        if (closedEl) closedEl.hidden = phase !== 'closed';

        if (phase === 'pre' && preEl) {
          var timer = preEl.querySelector('[data-auction-countdown]');
          updateCountdownTimer(timer, now);
        }
      });
    }

    tick();
    sectionIntervals[sectionId] = window.setInterval(tick, 1000);
  }

  function initNativeShare(root) {
    if (!root) return;

    var supportsNativeShare = typeof navigator !== 'undefined' && typeof navigator.share === 'function';
    var buttons = root.querySelectorAll('[data-auction-native-share]');

    Array.prototype.slice.call(buttons).forEach(function (button) {
      if (!supportsNativeShare) {
        button.hidden = true;
        return;
      }

      button.hidden = false;

      if (button.__auctionShareBound) return;
      button.__auctionShareBound = true;

      button.addEventListener('click', function () {
        var shareData = {};
        var title = button.getAttribute('data-auction-share-title');
        var text = button.getAttribute('data-auction-share-text');
        var url = button.getAttribute('data-auction-share-url');

        if (title) shareData.title = title;
        if (text) shareData.text = text;
        if (url) shareData.url = url;

        navigator.share(shareData).catch(function (error) {
          if (error && error.name === 'AbortError') return;
          console.error('Auction native share failed', error);
        });
      });
    });
  }

  function bootSection(root) {
    if (!root) return;
    initNativeShare(root);
    updateEmptyBlocks(root);

    var phaseRoots = root.querySelectorAll('[data-auction-phase-root]');
    if (phaseRoots.length) {
      initAuctionPhases(root, phaseRoots);
      return;
    }

    initCountdown(root);
  }

  function onSectionUnload(event) {
    var target = event && event.target;
    if (!target) return;

    var root = target.querySelector('[data-auction-section]');
    if (!root) return;

    var sectionId = root.getAttribute('id');
    if (sectionIntervals[sectionId]) {
      clearInterval(sectionIntervals[sectionId]);
      delete sectionIntervals[sectionId];
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.slice.call(document.querySelectorAll('[data-auction-section]')).forEach(bootSection);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var root = event && event.target ? event.target.querySelector('[data-auction-section]') : null;
    bootSection(root);
  });

  document.addEventListener('shopify:section:reorder', function (event) {
    var root = event && event.target ? event.target.querySelector('[data-auction-section]') : null;
    bootSection(root);
  });

  document.addEventListener('shopify:section:unload', onSectionUnload);
})();
